import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { AuthError } from '@juvare/platform-app/App';
import { ClassifierDef, defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns, ClassifierData } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns, EntityColumns } from '@juvare/platform-shared/features/storage';

export const hanRoleEntityName = 'hanRole';

export interface HanRoleData extends ClassifierData {
    description: string;
}

const hanRoleColumns = defineColumns({
    ...classifierColumns,
    description: {
        type: 'string',
    },
    search: {
        type: 'full-text-search-required',
        language: 'english',
    },
});

export type HanRoleColumns = EntityColumns<typeof hanRoleColumns>;

export type HanRoleDef = ClassifierDef<HanRoleData, HanRoleColumns>;

export function defineHanRoleClassifier(): HanRoleDef {
    return defineClassifierEntity<HanRoleData, HanRoleColumns>({
        entity: {
            version: 3,
            columns: hanRoleColumns,
            onMigrate: (params) => {
                const migratedData = params.oldData;
                if (params.oldVersions.includes(1)) {
                    migratedData.title = params.oldData.name;
                }
                if (params.oldVersions.includes(2) && params.newVersion === 3) {
                    delete migratedData.label;
                }
                return migratedData;
            },
            onTransformColumns: (context, params) => {
                return {
                    ...transformClassifierColumns(params),
                    description: params.data.description,
                    search: [params.data.name, params.data.status].join(' '),
                };
            },
            onAnonymousAuthGet: (appState, response) => response,
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (!requireAnySystemPermission(userState, 'manage-all-classifiers')) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData: [],
    });
}
